import { useState } from 'react';

import { Dialog, SwipeableViews } from '@cast/design-system';

import { Cluster } from 'types/cluster';
import { isE2E } from '@cast/utils';

import { EnablingSlide } from './_components/EnablingSlide';
import { ErrorSlide } from './_components/ErrorSlide';
import { RunTheScriptSlide } from './_components/RunTheScriptSlide';
import { SuccessSlide } from './_components/SuccessSlide';
import { useWasOmniEnabled } from '../../_hooks/useWasOmniEnabled';

import { ClusterProvider } from '@cast/shared-cluster-context-data-access';

type DialogStep = 'runTheScript' | 'enabling' | 'success' | 'error';

export type OmniCredentialsDialogProps = {
  cluster: Cluster;
  onCreateEdgeLocationClick?: () => void;
};

type Props = OmniCredentialsDialogProps & {
  onClose: () => void;
};

export const OmniCredentialsDialog = ({
  cluster,
  onCreateEdgeLocationClick,
  onClose,
}: Props) => {
  const [activeSlide, setActiveSlide] = useState<DialogStep>('runTheScript');

  useWasOmniEnabled({
    clusterId: cluster.id,
    enabled: activeSlide === 'enabling',
    onSuccess: () => setActiveSlide('success'),
    onError: () => setActiveSlide('error'),
  });

  return (
    <Dialog
      testId="omni-credentials-dialog"
      open
      fullWidth
      maxWidth="sm"
      onClose={onClose}
    >
      <ClusterProvider cluster={cluster}>
        <SwipeableViews
          slides={{
            runTheScript: ({ isActive }) =>
              isActive && <RunTheScriptSlide onClose={onClose} />,
            enabling: ({ isActive }) =>
              isActive && <EnablingSlide onClose={onClose} />,
            error: ({ isActive }) =>
              isActive && <ErrorSlide onClose={onClose} />,
            success: ({ isActive }) =>
              isActive && (
                <SuccessSlide
                  onClose={onClose}
                  onCreateEdgeLocationClick={onCreateEdgeLocationClick}
                />
              ),
          }}
          disableAnimations={isE2E()}
          activeSlide={activeSlide}
          onSlideChange={(slide) => setActiveSlide(slide)}
        />
      </ClusterProvider>
    </Dialog>
  );
};
